import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { SelectionModel } from '@angular/cdk/collections';
import { MatPaginator } from '@angular/material/paginator';
import { TankatableLstInformationDto } from 'sg-api';

/**
 * 早見表出力画面(検索結果)
 * @exports
 * @class Sgkc041dReferenceTableSearchResultComponent
 * @implements {OnInit, OnDestroy}
 */
@Component({
    selector: 'app-sgkc041d-reference-table-search-result',
    templateUrl: './sgkc041d-reference-table-search-result.component.html',
    styleUrl: './sgkc041d-reference-table-search-result.component.scss',
})
export class Sgkc041dReferenceTableSearchResultComponent implements OnInit, OnDestroy {
    /** セレクトボックス変更時のイベント */
    @Output() onSelectedEvent = new EventEmitter<TankatableLstInformationDto[]>();
    /** 単価表取得結果 */
    @Input() tankatable: TankatableLstInformationDto[];
    /** テーブルソート機能 */
    @ViewChild('sort', { static: true }) sort: MatSort;
    /** テーブルページネーション機能 */
    @ViewChild('paginator', { static: true }) paginator: MatPaginator;
    /** htmlテーブル選択情報 */
    selectionSearchResultDisplay: SelectionModel<TankatableLstInformationDto> = new SelectionModel<TankatableLstInformationDto>(true, []);
    /** htmlテーブルデータ */
    dataSourceSearchResultDisplay = new MatTableDataSource<TankatableLstInformationDto>();
    /** 検索結果表示リスト */
    displayedColumnsCol: string[] = [
        'select',
        'tankatableAname',
        'tankatableExplanation',
        'applyStartDate',
        'applyEndDate',
    ];

    /** 
    * コンストラクタ
    * @memberof Sgkc041dReferenceTableSearchResultComponent
    */
    constructor(
    ) { }

    /** 
     * 初期化処理
     * @memberof Sgkc041dReferenceTableSearchResultComponent
     */
    ngOnInit(): void {
        this.dataSourceSearchResultDisplay.data = this.tankatable;
    }

    /** 
     * ビュー初期化処理
     * @memberof Sgkc041dReferenceTableSearchResultComponent
     */
    ngAfterViewInit() {
        this.dataSourceSearchResultDisplay.paginator = this.paginator;
        this.dataSourceSearchResultDisplay.sort = this.sort;
    }

    /** 
     * コンポーネント破棄処理
     * @memberof Sgkc041dReferenceTableSearchResultComponent
     */
    ngOnDestroy(): void {
    }

    /** 
     * チェックボックス選択処理
     * @param {any} event
     * @param {SelectionModel<TankatableLstInformationDto>} selection
     * @memberof Sgkc041dReferenceTableSearchResultComponent
     */
    onChangeSelection(event: any, selection: SelectionModel<TankatableLstInformationDto>): void {
        if (event) {
            this.onSelectedEvent.emit(selection.selected);
        }
    }
}
